$(document).ready(function() {
  $(".sectionLink.newsletter-signup").click(function() {
    $(".newsletter-box").show();
  });
           
  $(".close-newletter-box").click(function() {
    $(".newsletter-box").hide();
  });

    window.onload = function () {
      setTimeout(function() {
        if (localStorage.getItem("hasCodeRunBefore") === null) {
          $(".sectionLink.newsletter-signup").trigger( "click" );
          localStorage.setItem("hasCodeRunBefore", true);
        }
      }, 10000);
    }
});